"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_style_proptype_1 = __importDefault(require("react-style-proptype"));
const emotion_1 = require("emotion");
class Tag extends react_1.PureComponent {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            this.props.onRemoveClick && this.props.onRemoveClick(this.props.value);
        };
    }
    render() {
        const _a = this.props, { label, value, removable, onRemoveClick, className, size, style } = _a, rest = __rest(_a, ["label", "value", "removable", "onRemoveClick", "className", "size", "style"]); // eslint-disable-line no-unused-vars
        return (react_1.default.createElement("span", Object.assign({ className: emotion_1.cx('tag', { [`label-${size}`]: size }, className), style: style }, rest),
            label !== undefined ? label : value,
            removable ? (react_1.default.createElement("button", { className: "close", onClick: this.handleClick }, "x")) : null));
    }
}
exports.default = Tag;
Tag.propTypes = {
    removable: prop_types_1.default.bool,
    onRemoveClick: prop_types_1.default.func,
    label: prop_types_1.default.node,
    value: prop_types_1.default.node,
    size: prop_types_1.default.oneOf(['sm', 'lg']),
    className: prop_types_1.default.string,
    style: react_style_proptype_1.default,
};
Tag.defaultProps = {
    className: '',
    removable: false,
    style: {},
};
